import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import type {
  IExportDataPayload,
} from '../types';
import {
  EXPORT_DATA_GENERATE_MUTATION_KEY,
  EXPORT_DATA_GENERATE_URL,
  EXPORT_DATA_PERMISSIONS,
} from '../constants';

export default function useExportDataGenerateMutation(): IContextMutationResult<
  void,
  Error,
  IExportDataPayload
> {
  const { fetchPost } = useRestClient();

  return useContextMutation<void, Error, IExportDataPayload>({
    mutationKey: [EXPORT_DATA_GENERATE_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(
      EXPORT_DATA_GENERATE_URL,
      payload,
      {
        permission: EXPORT_DATA_PERMISSIONS.CREATE,
      },
    ),
  });
}
